import { useEffect } from "react";

export default function SEO({ title, description, jsonLd }) {
  useEffect(() => {
    if (title) document.title = title;
    if (description) {
      const m = document.querySelector('meta[name="description"]');
      if (m) m.setAttribute("content", description);
    }
    const prev = document.getElementById("seo-jsonld");
    if (prev) prev.remove();
    if (jsonLd) {
      const tag = document.createElement("script");
      tag.type = "application/ld+json";
      tag.id = "seo-jsonld";
      tag.text = JSON.stringify(jsonLd);
      document.head.appendChild(tag);
    }
    return () => {
      const t = document.getElementById("seo-jsonld");
      if (t) t.remove();
    };
  }, [title, description, jsonLd]);
  return null;
}
